@if (navigationMode) {
  <div class="neighbor-widget">
    @if (navigationMode.parent) {
      <div
        class="neighbor-widget-button"
        [ngClass]="{ 'no-separator': !navigationMode.right}"
        @buttonAnimation
      >
        <button
          alg-button
          type="button"
          icon="ph-bold ph-caret-up"
          [showCaption]="!navigationMode.right"
          [withAnimation]="true"
          class="neighbor-nav"
          (click)="parent.emit()"
          i18n
        >Back</button>
      </div>
    }
    <div class="neighbor-widget-button" [ngClass]="{ 'no-separator': navigationMode.right}">
      <button
        alg-button-icon
        type="button"
        icon="ph-bold ph-caret-left"
        class="size-s no-bg nav-arrow"
        (click)="left.emit()"
        [disabled]="!navigationMode.left"
      ></button>
    </div>
    <div class="neighbor-widget-button">
      <button
        alg-button
        type="button"
        icon="ph-bold ph-caret-right"
        [showCaption]="navigationMode.right"
        [withAnimation]="true"
        class="neighbor-nav"
        data-testid="nav-to-next"
        (click)="right.emit()"
        [disabled]="!navigationMode.right"
        i18n
      >Next</button>
    </div>
  </div>
}
